module.exports = __webpack_public_path__ + "static/media/productCurvyLines.3a1df6c1.png";